import http from './base'
//exampleUrl接口方法名
// const exampleUrl = 'exampleUrl'

function response(promise, callback) {
  promise.then(res => {
    console.log("status1",res.status)
    return callback && callback([res.status, res.data])
  }).catch(error => {
    if (error.response) {
      console.log("status2",error)
      return callback && callback([error.response.status, error.response.data])
    } else {
      return callback && callback(['-1', error.message])
    }
  })
}

// 获取站点
const siteList = (param, callback) => {
  response(http.post('https://www.xqpark.cn/travelCard/citySite/getTravelCite', param), callback)
}
// 获取支付信息
const doH5Charged = (param, callback) => {
  response(http.post('http://hw.xqpark.cn:9191/pay/doH5Charged', param), callback)
}
// 获取城市信息
const getCompany = (param, callback) => {
  response(http.post('https://www.xqpark.cn/newWechat/rentalCar/getCompany', param), callback)
}
// /doc/docInfo
const docInfo = (param, callback) => {
  response(http.post('https://www.xqpark.cn/newWechat/doc/docInfo', param), callback)
}
export default {
  siteList,
  doH5Charged,
  getCompany,
  docInfo
}



// WEBPACK FOOTER //
// ./src/service/http.js